import { useCallback, useReducer } from 'react';

export enum CHECK_AVAILABILITY_ACTIONS_TYPES {
	SET_PARTIAL_DATA = 'SET_PARTIAL_DATA',
	SET_LOADING = 'SET_LOADING',
}

type StoreType = {
	class?: string;
	latitud?: number;
	longitud?: number;
	name?: string;
	quantity?: string;
	value?: string;
	_classname?: string;
	_type?: string;
};

export interface CheckAvailabilityState {
	loading: boolean;
	selectedState: string;
	cities: string[];
	stores: StoreType[];
	selectedCity: string;
}

const initialState: CheckAvailabilityState = {
	loading: false,
	selectedState: '',
	cities: [],
	selectedCity: '',
	stores: [],
};

export type CHECK_AVAILABILITY_ACTIONS =
	| {
			type: CHECK_AVAILABILITY_ACTIONS_TYPES.SET_PARTIAL_DATA;
			payload: Partial<CheckAvailabilityState>;
	  }
	| { type: CHECK_AVAILABILITY_ACTIONS_TYPES.SET_LOADING; payload: boolean };

const reducer = (
	state: CheckAvailabilityState,
	action: CHECK_AVAILABILITY_ACTIONS
): CheckAvailabilityState => {
	switch (action.type) {
		case CHECK_AVAILABILITY_ACTIONS_TYPES.SET_PARTIAL_DATA:
			return { ...state, ...action.payload };
		case CHECK_AVAILABILITY_ACTIONS_TYPES.SET_LOADING:
			return { ...state, loading: action.payload };
		default:
			return state;
	}
};

export const useCheckAvailabilityState = () => {
	const [checkAvailabilityState, dispatch] = useReducer(reducer, initialState);

	const onSetPartialCheckAvailabilityState = useCallback(
		(payload: Partial<CheckAvailabilityState>) => {
			dispatch({ type: CHECK_AVAILABILITY_ACTIONS_TYPES.SET_PARTIAL_DATA, payload });
		},
		[]
	);

	const onSetLoading = useCallback((payload: boolean) => {
		dispatch({ type: CHECK_AVAILABILITY_ACTIONS_TYPES.SET_LOADING, payload });
	}, []);

	return {
		checkAvailabilityState,
		onSetPartialCheckAvailabilityState,
		onSetLoading,
	};
};
